import * as React from 'react'

export const APMIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 36C46 37.1046 45.1046 38 44 38L16 38C14.8954 38 14 37.1046 14 36L14 22C14 20.8954 14.8954 20 16 20L44 20C45.1046 20 46 20.8954 46 22V36Z"
        fill="#5BBBFC"
      />
      <path
        d="M2 12C2 10.8954 2.89543 10 4 10H28C29.1046 10 30 10.8954 30 12V28C30 29.1046 29.1046 30 28 30H4C2.89543 30 2 29.1046 2 28V12Z"
        fill="#DD7F57"
      />
      <path
        d="M30 20V28C30 29.1046 29.1046 30 28 30H14L14 22C14 20.8954 14.8954 20 16 20L30 20Z"
        fill="#FAF8F5"
      />
      <path
        d="M23 29C23 25.134 26.134 22 30 22C33.866 22 37 25.134 37 29C37 32.866 33.866 36 30 36C26.134 36 23 32.866 23 29Z"
        fill="#001C64"
      />
      <path d="M2 14H30V18H2V14Z" fill="#4F2825" />
      <path
        d="M12 26.25C12 26.5261 11.7761 26.75 11.5 26.75H4.5C4.22386 26.75 4 26.5261 4 26.25V25.5C4 25.2239 4.22386 25 4.5 25H11.5C11.7761 25 12 25.2239 12 25.5V26.25Z"
        fill="#4F2825"
      />
      <path
        d="M23 29C23 25.134 26.134 22 30 22V28C30 29.1046 29.1046 30 28 30H23.0709C23.0242 29.6734 23 29.3395 23 29Z"
        fill="#4F2825"
      />
    </svg>
  )
})

APMIcon.displayName = 'APMIcon'
